/**
 * Clés d'idempotence.
 *
 * L'API en exige une sur `creditPack` et `consumeMission`. Elle porte
 * l'identité de l'intention : stable au rejeu d'un même fait, distincte entre
 * deux faits. Le serveur ne peut pas l'inventer — deux consommations de 500
 * tokens le même jour sur la même mission sont indiscernables vues du back.
 *
 * En production, cette clé serait la référence du paiement ou l'identifiant de
 * la ligne de feuille de temps. Dans le POC, elle est tirée au sort une fois
 * par intention, côté front.
 */

/**
 * Fabrique une clé neuve.
 *
 * À n'appeler **qu'au moment où une nouvelle intention naît** (l'utilisateur
 * choisit un pack, ouvre un formulaire), jamais à chaque clic sur « Valider » :
 * une clé neuve par tentative rendrait l'idempotence inopérante et créditerait
 * deux fois un même paiement rejoué. Dans un composant, passer par
 * `useIdempotencyKey`.
 */
export function newIdempotencyKey(prefix = "lde"): string {
  return `${prefix}-${crypto.randomUUID()}`;
}
